export const STATUS_UNCOMPLETED = 0
export const STATUS_ACTIVE = 1
export const STATUS_COMPLETED = 2
export const STATUS_SKIPPED = 3

export default {
    STATUS_UNCOMPLETED,
    STATUS_ACTIVE,
    STATUS_COMPLETED,
    STATUS_SKIPPED,
}
